export enum adminScoutsCompanyTypes {
    FETCH_ADMIN_SCOUTS_COMPANY_REQUEST = "FETCH_ADMIN_SCOUTS_COMPANY_REQUEST",
    FETCH_ADMIN_SCOUTS_COMPANY_SUCCESS = "FETCH_ADMIN_SCOUTS_COMPANY_SUCCESS",
    FETCH_ADMIN_SCOUTS_COMPANY_FAILURE = "FETCH_ADMIN_SCOUTS_COMPANY_FAILURE",
  }